module.exports = __webpack_public_path__ + "img/asset_STEP.34ac6a6e.svg";